import Board from "./components/board";
import "./components/style.css";

export default function App() {
  return (
    <div className="App" id="main">
      <Board></Board>
    </div>
  );
}
